<template>
    <el-dialog title="修改机台" :visible.sync="machineEditVisible" width="50%" :close-on-click-modal="false">
        <el-form :model="machine" :rules="machineRelues" ref="machineaEditForm" label-width="145px">
            <el-form-item label="机台编号:" prop="machineNumber">
                <el-input v-model="machine.machineNumber"></el-input>
            </el-form-item>
            <el-form-item label="所在车间:" prop="workshop">
                <el-input v-model="machine.workshop"></el-input>
            </el-form-item>
            <el-form-item label="轴长(米):" prop="warpKnittingMachineAxialLength">
                <el-input v-model="machine.warpKnittingMachineAxialLength"></el-input>
            </el-form-item>
            <el-form-item label="面梳(个):" prop="warpKnittingMachineMaxComb">
                <el-input v-model="machine.warpKnittingMachineMaxComb"></el-input>
            </el-form-item>
            <el-form-item label="机台类型:" prop="machineType">
                <el-input v-model="machine.machineType"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer">
            <el-button type="primary" @click="onSubmit()">修改</el-button>
            <el-button @click="cancel()">取消</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import * as api from '@/api/platform/machine/edit'
    export default {
        data() {
            var lengthruler = (rules, value, cb) => {
                const ruler = /(^[1-9]([0-9]*)$|^[1-9]$)/
                if (ruler.test(value)) {
                    return cb()
                }
                cb(new Error('请输入大于0的正整数'))
            }
            return {
                machineEditVisible: false,
                machine: {},
                machineRelues: {
                    machineNumber: [{
                        required: true,
                        message: '请输入机台编号',
                        trigger: 'blur'
                    }],
                    workshop: [{
                        required: true,
                        message: '请输入所属车间',
                        trigger: 'blur'
                    }],
                    warpKnittingMachineAxialLength: [{
                            required: true,
                            message: '请输入轴长',
                            trigger: 'blur'
                        },
                        {
                            validator: lengthruler,
                            trigger: 'blur'
                        }
                    ],
                    warpKnittingMachineMaxComb: [{
                            required: true,
                            message: '请输入面梳',
                            trigger: 'blur'
                        },
                        {
                            validator: lengthruler,
                            trigger: 'blur'
                        }
                    ],
                    machineType: [{
                        required: true,
                        message: '请输入机台类型',
                        trigger: 'blur'
                    }],
                }
            }
        },
        methods: {
            // 外部调用，显示修改机台弹框
            show(factoryId, id, machineId, machineNumber, workshop, warpKnittingMachineAxialLength,
                warpKnittingMachineMaxComb, machineType) {
                this.machine.factoryId = factoryId // 工厂ID
                this.machine.id = id
                this.machine.machineId = machineId

                // hongmj: 注意EditBox不能用直接赋值，会无法编辑。要用 set方法。
                this.$set(this.machine, 'machineNumber', machineNumber) // 机台编号
                this.$set(this.machine, 'workshop', workshop) // 所属车间
                this.$set(this.machine, 'warpKnittingMachineAxialLength', warpKnittingMachineAxialLength) // 轴长
                this.$set(this.machine, 'warpKnittingMachineMaxComb', warpKnittingMachineMaxComb) // 面梳
                this.$set(this.machine, 'machineType', machineType) // 机台类型

                this.machineEditVisible = true
            },

            // 点击创建按钮，创建机台
            onSubmit() {
                this.$refs.machineaEditForm.validate(valid => {
                    if (!valid) return
                    api.onSubmit(this.machine).then((res) => {
                        this.$Message.success('机台编辑成功!')
                        this.$emit('update')
                        this.machineEditVisible = false
                    })
                })
            },
            // 取消按钮
            cancel() {
                this.machineEditVisible = false
            }
        }
    }
</script>

<style lang="scss" scoped>
</style>
